import React, { useEffect } from 'react';
import styled from 'styled-components';
import HeaderNav from './HeaderNav';
import { useDispatch, useSelector } from 'react-redux';
import { fetchActivities } from '../../actions/activity';
import { fetchDeliverables } from '../../actions/deliverable';
import { fetchDepartments } from '../../actions/department';
import { fetchUsers, addUser, setUser } from '../../actions/user';
import EmailService from '../../helpers/email';
import { fetchObjectives } from '../../actions/objective';
import { fetchUpdate, updateTime } from '../../actions/update';
import { updatedToday } from '../../helpers';
import csvjson from '../../csvjson';

import { Link } from "react-router-dom";

const HeaderMain = styled.div`
                margin:30px 0 0 0;
                background:#fff;
                width:100%;
				@media (max-width: 991px) {
                    position:fixed;
                    z-index:9999;
                    margin:0 0 0 0;
				}
                @media (min-width: 1190px) {
                    .container{
                        width:1190px!important;
                    } 
                }
                .header-mobile{
                    background: #fff;
                }
                img{
                    width:100%;
                }
                @media (max-width: 991px) {
                    box-shadow: 0 4px 2px -2px gray;
                    padding-bottom: 15px;
                    img{
                        width:initial;
                    }
                }
                .initial{
                    background: rgb(229, 243, 254) none repeat scroll 0% 0%;
                    width: 60px;
                    height: 60px;
                    margin: auto;
                    line-height: 60px;
                    border-radius: 50%;
                    color: rgb(1, 132, 254);const [activity, setActivity] = useState(props.item ? props.item : _getActivityObject());
                    display: inline-block;
                    text-align: center;
                }
`;

function Header(props) {
    const dispatch = useDispatch();
    const users = useSelector(state => state.users);
    const last_updated = useSelector(state => state.last_updated);
    const activities = useSelector(state => state.activities);
    const currentUser = useSelector(state => state.currentUser);
    let user = window.user ? window.user.replace(new RegExp('&#34;', 'g'), '"') : null;
    user = JSON.parse(user);

    useEffect(() => {
        dispatch(fetchActivities());
        dispatch(fetchDepartments());
        dispatch(fetchDeliverables());
        dispatch(fetchUsers());
        dispatch(fetchObjectives());
        dispatch(fetchUpdate());
    }, []);

    if (last_updated.last_updated) {
        if (!updatedToday(last_updated.last_updated)) {
            let email = new EmailService();
            email.handleApproachingItems(activities);
            dispatch(updateTime());
        }
    }
    if (users.length > 0 && (user && user.email)) {
        if (users.findIndex(x => x.email === user.email) === -1) {
            dispatch(addUser({ email: user.email, name: user.name.givenName, surname: user.name.familyName, role: 'member' }));
        } else {
            dispatch(setUser(users[users.findIndex(x => x.email === user.email)]));
        }

    }

    return (
        <HeaderMain>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="row show-mobile">
                            <div className="header-mobile">
                                <div className="col-sm-12">
                                    <div className="row pt-3">
                                        <div className="col-sm-12 align-center">
                                            <Link to={'/'}>
                                                <img src="/assets/images/Arc_logo.png" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row show-desktop">
                            <div className="col-2">
                                <div className="row">
                                    <div className="col-8 offset-2">
                                        <Link to={'/'}>
                                            <img src="/assets/images/Arc_logo.png" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-8 text-center">
                                <HeaderNav />
                            </div>
                            <div className="col-2">
                                {
                                    user ?
                                        <div class="initial">
                                            {user.name.givenName.charAt(0)}
                                            {user.name.familyName.charAt(0)}</div>
                                        : ''
                                }
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </HeaderMain>
    );
}

export default Header;